import { fetchExtended } from '@module/utils/fetch/client-fetch';
import type {
  GetChatEmoticonGroupParams,
  GetChatEmoticonGroupResponse,
  GetChatEmoticonParams,
  GetChatEmoticonResponse,
} from './type';

export const getChatEmoticon = async (params: GetChatEmoticonParams) => {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value == null) return;
    searchParams.append(key, String(value));
  });

  const res = await fetchExtended(`/v1/chat_emoticon/index?${searchParams.toString()}`, {
    method: 'GET',
    credentials: 'include',
  });

  const result = await res.json();

  return result as GetChatEmoticonResponse;
};

export const getChatEmoticonGroup = async (params: GetChatEmoticonGroupParams) => {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value == null) return;
    searchParams.append(key, String(value));
  });

  const res = await fetchExtended(`/v1/chat_emoticon/group?${searchParams.toString()}`, {
    method: 'GET',
    credentials: 'include',
  });

  const result = await res.json();

  return result as GetChatEmoticonGroupResponse;
};
